<template>
 <UContainer>
      <UPageLogos marquee :items="items" :ui="{
        logo: 'rounded-none *:object-contain bg-0 size-[150px_90px]',
      }"/>
</UContainer>
</template>
<script setup lang="ts">
const items = [
    {
        src: "https://placehold.co/250x150/EEE/31343C",
        alt: "Placeholder Logo 1"
    },
        {
        src: "https://placehold.co/250x150/EEE/31343C",
        alt: "Placeholder Logo 1"
    },
        {
        src: "https://placehold.co/250x150/EEE/31343C",
        alt: "Placeholder Logo 1"
    },
        {
        src: "https://placehold.co/250x150/EEE/31343C",
        alt: "Placeholder Logo 1"
    },
        {
        src: "https://placehold.co/250x150/EEE/31343C",
        alt: "Placeholder Logo 1"
    }
]
</script>